import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (typeof window !== 'undefined') {
  // Immediately extract and scrub the password reset token from URL to prevent analytics leaks (GA4/Bing)
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  if (code && window.location.pathname.includes('/site/revivepass')) {
    sessionStorage.setItem('temp_reset_code', code);
    urlParams.delete('code');
    const newSearch = urlParams.toString();
    const newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    window.history.replaceState({}, document.title, newUrl);
  }

  const originalLog = console.log;
  const originalInfo = console.info;
  const originalWarn = console.warn;
  const originalError = console.error;
  const originalDebug = console.debug;

  const sensitiveKeys = [
    'token', 'cvv', 'cvc', 'expiry', 'card', 'pass', 'upi', 'email', 'first_name', 'last_name',
    'mobile', 'address', 'virtual_address', 'gst', 'phone', 'pan', 'number', 'name'
  ];

  const redactValue = (val: any): any => {
    if (val === null || val === undefined) return val;
    if (typeof val === 'string') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const cardRegex = /\b\d{13,19}\b/;
      const tokenRegex = /ey[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*/;
      if (emailRegex.test(val) || cardRegex.test(val) || tokenRegex.test(val)) {
        return '[REDACTED]';
      }
      return val;
    }
    if (Array.isArray(val)) {
      return val.map(redactValue);
    }
    if (typeof val === 'object') {
      const copy: any = {};
      for (const k in val) {
        if (Object.prototype.hasOwnProperty.call(val, k)) {
          const kLower = k.toLowerCase();
          if (sensitiveKeys.some(key => kLower.includes(key))) {
            copy[k] = '[REDACTED]';
          } else {
            copy[k] = redactValue(val[k]);
          }
        }
      }
      return copy;
    }
    return val;
  };

  const sanitizeArgs = (args: any[]) => args.map(redactValue);

  if (environment.production) {
    const noop = () => {};
    console.log = noop; console.info = noop; console.warn = noop; console.error = noop; console.debug = noop;
  } else {
    // console.log = (...args: any[]) => originalLog.apply(console, sanitizeArgs(args));
    // console.info = (...args: any[]) => originalInfo.apply(console, sanitizeArgs(args));
    // console.warn = (...args: any[]) => originalWarn.apply(console, sanitizeArgs(args));
    // console.error = (...args: any[]) => originalError.apply(console, sanitizeArgs(args));
    // console.debug = (...args: any[]) => originalDebug.apply(console, sanitizeArgs(args));
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    if (typeof window !== 'undefined') {
      // If bootstrapped fails in the browser, log to stderr / original console before suppression if possible,
      // but since it's overridden, we just fall back gracefully.
    } else {
      console.error(err);
    }
  });
